"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockUrl = void 0;
const blockUrl = (url) => {
    const iamIPPattern = /169.254.169.254/;
    const iamDomainPattern = /instance-data/;
    return iamIPPattern.test(url) || iamDomainPattern.test(url);
};
exports.blockUrl = blockUrl;
